import { Injectable } from '@angular/core';
import { TipoVeiculo } from '@tivic-team/manager-ts/dist/fta';
import { TipoVeiculoController } from 'app/controllers/fta/tipo-veiculo.controller';
import { LoaderService } from '../loader.service';
import { TipoVeiculoSearch } from './tipo-veiculo.search';


@Injectable()
export class TipoVeiculoService {

  constructor(
    private _tipoVeiculoController: TipoVeiculoController,
    private _loaderService: LoaderService
  ) {}

  async getAll (isLoading:boolean=true):Promise<TipoVeiculo[]>{
    try{
      if(isLoading) this._loaderService.show();
      return await this._tipoVeiculoController.getAllTypesVehicles().finally(() => {if (isLoading) this._loaderService.hide()});
    }catch(error){return [];}
  }  

  async get(cdTipoVeiculo:number):Promise<TipoVeiculo>{
    
    this._loaderService.show();
    return this._tipoVeiculoController.get(cdTipoVeiculo).finally(() => this._loaderService.hide());
  }

  async find(tipoVeiculoSearch?: TipoVeiculoSearch):Promise<Array<TipoVeiculo>>{
    this._loaderService.show();
    return await this._tipoVeiculoController.find(tipoVeiculoSearch && tipoVeiculoSearch.getFilters())
    .finally(()=> this._loaderService.hide());
  }

  async findTipoVeiculo( tipoVeiculoSearch?: TipoVeiculoSearch ): Promise<TipoVeiculo[]> {
      this._loaderService.show();
    try {
      return await this._tipoVeiculoController.find(
        (tipoVeiculoSearch && tipoVeiculoSearch.getFilters()) || null
      ).finally(() => this._loaderService.hide());
    } catch (error) {
      this._loaderService.hide();
      return [];
    }
  }

  async save( tipoVeiculo: TipoVeiculo ): Promise<TipoVeiculo> {
    this._loaderService.show();

    if( tipoVeiculo.cdTipoVeiculo && tipoVeiculo.cdTipoVeiculo > 0 ) {
      return this._tipoVeiculoController.update( tipoVeiculo ).finally( () => this._loaderService.hide());

    } else {
      return this._tipoVeiculoController.create( tipoVeiculo ).finally(() => this._loaderService.hide());
    }
  }
}
